// @flow
import React, { type Node } from 'react';
import { default as ReactPopOver } from 'react-popover'; // eslint-disable-line
import './stylesheets/PopOver.scss';

type Props = {
  content: Node,
  children: Node,
  preferPlace: string
};

type State = {
  show: boolean
};

const MS_TO_SHOW_POPOVER = 250;

export default class PopOver extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { show: false };
    this.showPopOver = this.showPopOver.bind(this);
    this.hidePopOver = this.hidePopOver.bind(this);
  }

  timeout: ?*;

  showPopOver: Function = () => {
    this.timeout = setTimeout(
      () => this.setState({ show: true }),
      MS_TO_SHOW_POPOVER
    );
  };

  hidePopOver: Function = () => {
    this.setState({ show: false });
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  };

  render() {
    const { content, children, preferPlace = 'column' } = this.props;
    const { show } = this.state;

    return (
      <div onMouseEnter={this.showPopOver} onMouseLeave={this.hidePopOver}>
        <ReactPopOver
          body={content}
          preferPlace={preferPlace}
          isOpen={show}
          refreshIntervalMs={0}
          enterExitTransitionDurationMs={0}
        >
          {children}
        </ReactPopOver>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PopOver.jsx